export default {
  name: 'Acalendar',
  props: {
    value: null
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (<el-calendar v-model={value} {...{ attrs }}>{this.$slots.default}</el-calendar>);
  }
}